<template>
  <Modal
    ref="modal"
    title="Disqualified Candidate Settings"
    action="Save"
    actionColor="indigo"
    @closeModal="handleCancelSettings"
    @handleAction="updateTeam"
  >
    <TextAreaInput label="Disqualified Rejection Email" />
  </Modal>
</template>

<script>
import Modal from '../../../shared/Modal.vue';

export default {
  components: {
    Modal,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleCancelSettings() {
      this.$emit('handleCancelSettings');
    },
  },
};
</script>
